import React from "react";
// material ui
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

// ------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  root: {
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 500,
      color: "rgba(0, 0,  0)",
      backgroundColor: "#fff",
    },
    "& .css-1sumxir-MuiFormLabel-root-MuiInputLabel-root": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 500,
      color: "rgba(0, 0, 0)",
      backgroundColor: "#fff",
    },
    "& .css-1z7n62": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 500,
      color: "rgba(0, 0, 0)",
    },
    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      fontFamily: "Arial",
      fontSize: "1rem",
      fontWeight: 400,
    },
  },
}));

// ------------------------------------------------------------

const MyTextInput = ({
  label,
  type,
  id,
  name,
  value,
  onBlur,
  onChange,
  required,
  fullWidth,
  normalize,
  size,
  margin,
  variant,
  disabled,
  error,
  helperText,
  autoFocus,
  tabIndex,
  ref,

  ...otherProps
}) => {
  const classes = useStyles();
  return (
    <TextField
      label={label}
      type={type}
      id={id}
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      required={required}
      fullWidth={fullWidth}
      size={size}
      margin={margin}
      variant={variant}
      disabled={disabled}
      error={error}
      helperText={helperText}
      className={classes.root}
      autoFocus={autoFocus}
      {...otherProps}
      ref={ref}
      sx={{ backgroundColor: "#fff" }}
      inputProps={{ tabIndex: tabIndex }}
    ></TextField>
  );
};

export default MyTextInput;
